import React from "react";
import moment from "moment";
import { formatDot } from "../../util/rekapAbsensiUtils";
import "./RincianPerhitunganPayroll.css";

const SECURITY_SHIFT_HOURS = 8;

export const Divider = () => <div className="rekap-full-row rekap-divider" />;

export const RumusRow = ({
  label,
  value,
  bold,
  highlight,
  negative,
  colorVariant,
}) => {
  const isString = typeof value === "string";
  const hasEquals = isString && value.includes(" = ");
  const formula = hasEquals ? value.split(" = ")[0] : "";
  const result = hasEquals ? value.split(" = ")[1] : value;

  const resultClass = [
    "rumus-row-result",
    negative && "negative",
    !negative && highlight && "highlight",
    !negative && colorVariant === "blue" && "color-blue",
    !negative && colorVariant === "orange" && "color-orange",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={`rumus-row${bold ? " bold" : ""}`}>
      <span>{label}</span>
      <span className="rumus-row-formula">{formula}</span>
      <span className="rumus-row-eq">{hasEquals ? "=" : ""}</span>
      <span className={resultClass}>{result}</span>
    </div>
  );
};

const rumusSetengahHari = (
  hariHalf,
  jamHalf,
  daySallary,
  total,
  jamPerHari = 7
) => {
  const hasil = `Rp ${formatDot(total)}`;
  if (jamHalf === undefined) {
    return `${hariHalf} x 0,5 x Rp ${formatDot(daySallary)} = ${hasil}`;
  }
  return `${Number(jamHalf).toFixed(2)} Jam x Rp ${formatDot(
    daySallary / jamPerHari
  )} = ${hasil}`;
};

const RincianPerhitunganPayroll = ({
  row,
  typeKaryawan,
  periodeStart,
  bagian,
  keteranganKurangBayar = "",
  keteranganLebihBayar = "",
}) => {
  const isPermanentFilter = typeKaryawan === "permanent";
  const employeeType = row.employeeType;
  const bukanSecurity = !(bagian || "").toLowerCase().includes("security");

  const adaProbation =
    (row.basicSallaryProbation || 0) > 0 ||
    row.totalHariKerjaProbation > 0 ||
    row.totalLemburProbation > 0 ||
    row.totalLemburJamProbation > 0 ||
    row.uangShiftOneProbation > 0;

  const monthBpjs = moment
    .utc(periodeStart)
    .utcOffset(7)
    .add(1, "month")
    .format("MMM YYYY");

  return (
    <div className="rekap-detail-col-kiri">
      <RumusRow
        label="Gaji"
        value={
          employeeType === "Permanent"
            ? `Rp ${formatDot(row.totalGaji)}`
            : `${(row.totalJamKerja / 7).toFixed(2)} Hari X Rp ${formatDot(
                row.daySallary
              )} = Rp ${formatDot(row.totalGaji)}`
        }
        bold
        highlight
      />

      {bukanSecurity && (
        <RumusRow
          label="Gaji Setengah Hari"
          value={rumusSetengahHari(
            row.hariHalf,
            row.jamHalf,
            row.daySallary,
            row.totalGajiSetengahHari
          )}
        />
      )}

      {!isPermanentFilter && row.totalLembur > 0 && (
        <RumusRow
          label="Total Lembur (Hari)"
          value={`${formatDot(row.totalLembur)} Hari x 2 = Rp ${formatDot(
            row.totalLemburRp
          )}`}
          colorVariant="blue"
        />
      )}

      {!isPermanentFilter && row.totalLemburJam > 0 && (
        <RumusRow
          label="Total Lembur (Jam)"
          value={`${row.totalLemburJam} Jam x Rp ${formatDot(
            row.daySallary
          )} = Rp ${formatDot(row.totalLemburJamRp)}`}
          colorVariant="blue"
        />
      )}

      {!isPermanentFilter && bukanSecurity && row.uangShiftOne > 0 && (
        <RumusRow
          label="Uang Shift 1"
          value={`${row.uangShiftOne} x Rp 4.000 = Rp ${formatDot(
            row.uangShiftOneRp
          )}`}
          colorVariant="blue"
        />
      )}

      {!isPermanentFilter && adaProbation && (
        <>
          <RumusRow
            label="Gaji Probation"
            value={
              employeeType === "Permanent"
                ? `Rp ${formatDot(row.totalGajiProbation)}`
                : `${(row.totalJamKerjaProbation / 7).toFixed(
                    2
                  )} Hari X Rp ${formatDot(
                    row.daySallaryProbation
                  )} = Rp ${formatDot(row.totalGajiProbation)}`
            }
            bold
            colorVariant="orange"
          />
          {bukanSecurity && (
            <RumusRow
              label="Gaji Setengah Hari Probation"
              value={rumusSetengahHari(
                row.hariHalfProbation,
                row.jamHalfProbation,
                row.daySallaryProbation,
                row.totalGajiSetengahHariProbation
              )}
              colorVariant="orange"
            />
          )}
          {row.totalLemburProbation > 0 && (
            <RumusRow
              label="Total Lembur Probation"
              value={`${formatDot(
                row.totalLemburProbation
              )} Hari x 2 = ${formatDot(row.totalLemburProbationRp)}`}
              colorVariant="orange"
            />
          )}

          {row.totalLemburJamProbation > 0 && (
            <RumusRow
              label="Total Lembur (Jam) Probation"
              value={`${row.totalLemburJamProbation} Jam x Rp ${formatDot(
                row.daySallaryProbation
              )} = Rp ${formatDot(row.totalLemburJamProbationRp)}`}
              colorVariant="orange"
            />
          )}

          {row.uangShiftOneProbation > 0 && bukanSecurity && (
            <RumusRow
              label="Uang Shift 1 Probation"
              value={`${row.uangShiftOneProbation} x Rp 4.000 = Rp ${formatDot(
                row.uangShiftOneProbationRp
              )}`}
              colorVariant="orange"
            />
          )}
        </>
      )}

      {row.uangTransport === 0 &&
        row.uangMakan === 0 &&
        employeeType !== "Permanent" && (
          <div className="rekap-full-row rekap-tunjangan-note">
            *Uang Transport, Uang Makan &amp; BPJS hanya berlaku untuk periode
            tanggal 13 - 26
          </div>
        )}

      <RumusRow
        label="Uang Transport"
        value={`Rp ${formatDot(row.uangTransport)}`}
      />
      <RumusRow label="Uang Makan" value={`Rp ${formatDot(row.uangMakan)}`} />

      {row.kurangBayar > 0 && (
        <>
          <Divider />
          <RumusRow
            label="Kurang Bayar"
            value={
              keteranganKurangBayar
                ? `${keteranganKurangBayar} = Rp ${formatDot(row.kurangBayar)}`
                : `Rp ${formatDot(row.kurangBayar)}`
            }
            highlight
          />
        </>
      )}

      <Divider />
      <RumusRow
        label="Total Sebelum Potongan"
        value={`Rp ${formatDot(row.totalSebelumPotongan)}`}
        bold
      />
      {row.lebihBayar > 0 && (
        <RumusRow
          label="Lebih Bayar"
          value={
            keteranganLebihBayar
              ? `${keteranganLebihBayar} = Rp ${formatDot(row.lebihBayar)}`
              : `Rp ${formatDot(row.lebihBayar)}`
          }
          colorVariant="blue"
          negative
        />
      )}
      {row.potonganIzinDitolak > 0 && (
        <RumusRow
          label="Potongan Izin/Sakit Ditolak"
          value={`${row.totalIzinDitolak} Hari x Rp ${formatDot(
            row.daySallary
          )} = Rp ${formatDot(row.potonganIzinDitolak)}`}
          negative
        />
      )}
      {row.potonganIzinDitolakProbation > 0 && (
        <RumusRow
          label="Potongan Izin/Sakit Ditolak (Probation)"
          value={`${row.totalIzinDitolakProbation} Hari x Rp ${formatDot(
            row.daySallaryProbation
          )} = Rp ${formatDot(row.potonganIzinDitolakProbation)}`}
          negative
        />
      )}
      {row.potonganAlpha > 0 && (
        <RumusRow
          label="Potongan Alpha"
          value={`${row.totalAlpha} Hari x Rp ${formatDot(
            row.daySallary
          )} = Rp ${formatDot(row.potonganAlpha)}`}
          negative
        />
      )}
      {row.potonganAlphaProbation > 0 && (
        <RumusRow
          label="Potongan Alpha (Probation)"
          value={`${row.totalAlphaProbation} Hari x Rp ${formatDot(
            row.daySallaryProbation
          )} = Rp ${formatDot(row.potonganAlphaProbation)}`}
          negative
        />
      )}
      {row.potonganSetengahHari > 0 && (
        <RumusRow
          label="Potongan Sisa Jam Setengah Hari"
          value={`${Number(row.jamPotonganSetengahHari).toFixed(
            2
          )} Jam x Rp ${formatDot(row.daySallary / 7)} = Rp ${formatDot(
            row.potonganSetengahHari
          )}`}
          negative
        />
      )}
      {row.potonganJamSecurity > 0 && (
        <RumusRow
          label="Potongan Gaji Security (Per Jam)"
          value={`${Number(row.jamPotonganSecurity).toFixed(
            2
          )} Jam x Rp ${formatDot(
            row.daySallary / SECURITY_SHIFT_HOURS
          )} = Rp ${formatDot(row.potonganJamSecurity)}`}
          negative
        />
      )}
      {row.potonganUangMakanSecurity > 0 && (
        <RumusRow
          label="Potongan Uang Makan Security (Per Hari)"
          value={`${row.hariPotongUangMakanSecurity} Hari x Rp ${formatDot(
            row.uangMakanPerHariSecurity
          )} = Rp ${formatDot(row.potonganUangMakanSecurity)}`}
          negative
        />
      )}
      {row.potonganUangMakanIzinDitolakSecurity > 0 && (
        <RumusRow
          label="Potongan Uang Makan Izin/Sakit Ditolak (Security)"
          value={`${
            row.hariPotongUangMakanIzinDitolakSecurity
          } Hari x Rp ${formatDot(
            row.uangMakanPerHariSecurity
          )} = Rp ${formatDot(row.potonganUangMakanIzinDitolakSecurity)}`}
          negative
        />
      )}
      <Divider />

      <RumusRow
        label={`Potongan BPJS TK (${monthBpjs})`}
        value={`Rp ${formatDot(row.bpjsTK)}`}
        negative
      />
      <RumusRow
        label={`Potongan BPJS K (${monthBpjs})`}
        value={`Rp ${formatDot(row.bpjsK)}`}
        negative
      />

      <Divider />
      <RumusRow
        label="Jumlah Yang Diterima"
        value={`Rp ${formatDot(row.takeHomePay)}`}
        bold
        highlight
      />
    </div>
  );
};

export default RincianPerhitunganPayroll;
